import type { CSSProperties } from "react";
import { COLORS, RADIUS, SPACE } from "../theme/index.js";

type SkeletonProps = { width?: number | string; height?: number | string; style?: CSSProperties };

export function Skeleton({ width = "100%", height = 16, style }: SkeletonProps) {
  return (
    <div
      style={{
        width,
        height,
        borderRadius: RADIUS.base,
        background: `linear-gradient(90deg, ${COLORS.surface} 25%, ${COLORS.surfaceHigh} 50%, ${COLORS.surface} 75%)`,
        backgroundSize: "200% 100%",
        animation: "shimmer 1.8s ease-in-out infinite",
        ...style,
      }}
    />
  );
}

export function SkeletonCard({ style }: { style?: CSSProperties }) {
  return (
    <div
      style={{ background: COLORS.surface, borderRadius: RADIUS.xl, padding: SPACE[5], ...style }}
    >
      <Skeleton height={20} width="60%" style={{ marginBottom: SPACE[3] }} />
      <Skeleton height={14} width="80%" style={{ marginBottom: SPACE[2] }} />
      <Skeleton height={14} width="50%" />
    </div>
  );
}

export function SkeletonRow({ style }: { style?: CSSProperties }) {
  return (
    <div
      style={{
        display: "flex",
        gap: SPACE[4],
        alignItems: "center",
        padding: `${SPACE[3]}px 0`,
        ...style,
      }}
    >
      <Skeleton width={32} height={32} style={{ borderRadius: "50%", flexShrink: 0 }} />
      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: SPACE[2] }}>
        <Skeleton height={14} width="40%" />
        <Skeleton height={12} width="60%" />
      </div>
    </div>
  );
}
